var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M19.736 6.56L44.264 32 19.736 57.44","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronRightInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
